import { TranslationData } from "@common";
import { LangContext } from "@natklok/contexts/langContext";
import { useContext } from "react";

const useTranslateTranslationData = (): ((key: TranslationData | undefined) => string) => {
  const { translateTranslationData } = useContext(LangContext);
  return translateTranslationData;
};

export default useTranslateTranslationData;
